import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ExamIcon: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.911 6.02753C6.12266 4.72759 7.84821 4 9.88572 4H20.2669C22.3092 4 24.0354 4.72719 25.2466 6.02788C26.4508 7.32112 27.0769 9.10633 27.0769 11.1094V20.8906C27.0769 22.8937 26.4508 24.6789 25.2464 25.9722C24.0351 27.2729 22.3084 28 20.2657 28H9.88572C7.84343 28 6.11737 27.2727 4.90653 25.9721C3.70265 24.6788 3.0769 22.8935 3.0769 20.8906V11.1094C3.0769 9.1053 3.70604 7.32026 4.911 6.02753ZM6.26146 7.2863C5.42797 8.1805 4.92306 9.48863 4.92306 11.1094V20.8906C4.92306 22.5125 5.42596 23.8204 6.25784 24.7141C7.08275 25.6004 8.29956 26.1538 9.88572 26.1538H20.2657C21.8525 26.1538 23.07 25.6002 23.8954 24.714C24.7276 23.8203 25.2308 22.5124 25.2308 20.8906V11.1094C25.2308 9.48761 24.7276 8.17966 23.8955 7.28596C23.0703 6.39969 21.853 5.84615 20.2669 5.84615H9.88572C8.30556 5.84615 7.08824 6.3993 6.26146 7.2863Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0239 20.0671C15.0239 19.5573 15.4372 19.144 15.947 19.144H21.252C21.7618 19.144 22.1751 19.5573 22.1751 20.0671C22.1751 20.5769 21.7618 20.9902 21.252 20.9902H15.947C15.4372 20.9902 15.0239 20.5769 15.0239 20.0671Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1371 17.5879C13.4974 17.9485 13.4972 18.533 13.1367 18.8934L11.1631 20.8657C10.8026 21.2259 10.2183 21.2259 9.85791 20.8654L8.84483 19.8524C8.48434 19.4919 8.48434 18.9074 8.84483 18.5469C9.20531 18.1864 9.78977 18.1864 10.1503 18.5469L10.5108 18.9075L11.8316 17.5875C12.1922 17.2272 12.7767 17.2274 13.1371 17.5879Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1371 11.1358C13.4974 11.4964 13.4972 12.0808 13.1367 12.4412L11.1631 14.4135C10.8026 14.7738 10.2183 14.7738 9.85791 14.4133L8.84483 13.4002C8.48434 13.0397 8.48434 12.4553 8.84483 12.0948C9.20531 11.7343 9.78977 11.7343 10.1503 12.0948L10.5108 12.4554L11.8316 11.1354C12.1922 10.775 12.7767 10.7752 13.1371 11.1358Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0239 13.6203C15.0239 13.1105 15.4372 12.6973 15.947 12.6973H21.252C21.7618 12.6973 22.1751 13.1105 22.1751 13.6203C22.1751 14.1301 21.7618 14.5434 21.252 14.5434H15.947C15.4372 14.5434 15.0239 14.1301 15.0239 13.6203Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default ExamIcon;
